export * from './cache';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/index.ts